import * as api from '../../api'
import React, { useCallback, useEffect, useState } from 'react'
import { Link, useHistory, useLocation } from 'react-router-dom'
import { useDispatch } from 'react-redux'

import decode from 'jwt-decode'

import Logo from '../../images/logo.svg'

import { LOGOUT } from '../../constants/actionTypes'
import { ArrowDropDown, Close, DashboardOutlined, ExitToApp, Menu, SettingsOutlined } from '@material-ui/icons'

import dayjs from 'dayjs'
import relativeTime from 'dayjs/plugin/relativeTime'

import Sidebar from '../../components/Sidebar/Sidebar'
import Profile from '../../components/Translator/Profile/Profile'
import Index from '../../components/Translator/Index/Index'
import New from '../../components/Translator/New/New'
import Ongoing from '../../components/Translator/Ongoing/Ongoing'
import Declined from '../../components/Translator/Declined/Declined'

import { ALERT } from '../../constants/actionTypes'
import { EditOutlined, EmailOutlined, KeyboardArrowLeft, StarRate } from '@material-ui/icons'

import './Translator.css'

const Translator = ({ match }) => {
    dayjs.extend(relativeTime)
    const dispatch = useDispatch()
    const history = useHistory()
    const section = match.params.section
    const location = useLocation()
    const [type, setType] = useState('image')
    const [loading, setLoading] = useState(true)
    const [reapplying, setReapplying] = useState(false)
    const [changing, setChanging] = useState(false)
    const [user, setUser] = useState()
    const [image, setImage] = useState('')
    const [showMessage, setShowMessage] = useState(false)
    const [showSidebar, setShowSidebar] = useState(false)
    const [auth, setAuth] = useState(JSON.parse(localStorage.getItem('auth')))
    const rating = user?.rating ? user?.rating.total_stars / user?.rating.total_rating : 0

    const handleReapply = async () => {
        setReapplying(true)

        try {
            await api.updateUser(user._id, { 'membership.applied': true, 'membership.approved': false })
            await api.counter({ unapproved_translators: 1 })
            setUser({...user, membership: {...user?.membership, applied: true, approved: false}})
            closeModal()
        } catch (error) {
            console.log(error)
            if(error.response) dispatch({ type: ALERT, payload: { severity: 'error', message: error.response.data.message, duration: 5000, display: true }})
            else {dispatch({ type: ALERT, payload: { severity: 'error', message: 'An unexpected error occurred', duration: 5000, display: true }})}
        } finally {
            setReapplying(false)
        }
    }

    const handleChange = async (e) => {
        const reader = new FileReader()
        
        reader.readAsDataURL(e.target.files[0])
    
        await reader.addEventListener('load', () => {
            setImage(reader.result)
        })
        
        openModal('image')

    }

    const openModal = (type) => {
        setType(type)
        document.querySelector('.translator__details').open = true
    }

    const closeModal = () => {
        setType('')
        document.querySelector('.translator__details').open = false
    }

    const logout = useCallback(() => {
        if(!auth) history.push('/auth/signin')

        setAuth(null)
        dispatch({ type: LOGOUT })
    }, [dispatch, history, auth])

    const handleToDashboard = () => {
        if(auth.role === 'basic') history.push('/projects/index')
        if(auth.role === 'translator') history.push('/translator/profile')
        if(auth.role === 'admin') history.push('/admin/index')
    }

    const handleChangeImage = async (e) => {
        e.preventDefault()
        setChanging(true)
        
        try {
            await api.updateUser(user._id, { profileImage: image })
            setUser({ ...user, profileImage: image })
            closeModal()
        } catch (error) {
            if(error.response) dispatch({ type: ALERT, payload: { severity: 'error', message: error.response.data.message, duration: 5000, display: true }})
            else dispatch({ type: ALERT, payload: { severity: 'error', message: 'An unexpected error occurred', duration: 5000, display: true }})
        } finally {
            setChanging(false)
        }
    }

    useEffect(() => {
        const token = auth?.token

        if(token) {
            const decodedToken = decode(token)

            if(decodedToken.exp * 1000 < new Date().getTime()) logout()
        }

        if(!auth) return history.replace('/auth/signin')

        if(auth.role !== 'translator') return history.replace('/not-found')
    }, [auth, location, history, logout])

    useEffect(() => {
        const getUser = async () => {
            try {
                const { data } = await api.getUser({ email: JSON.parse(localStorage.getItem('auth')).email })
                setUser(data)
                setLoading(false)
            } catch (error) {
                if(error.response) dispatch({ type: ALERT, payload: { severity: 'error', message: error.response.data.message, duration: 5000, display: true }})
                else dispatch({ type: ALERT, payload: { severity: 'error', message: 'An unexpected error occurred', duration: 5000, display: true }})
            }
        }
        
        if(auth?.role === 'translator') getUser()
    }, [auth, dispatch])

    return (
        <>
            {showSidebar && <div className="translator__overlay z-2" onClick={() => setShowSidebar(false)}></div>}
            {auth?.role === 'translator' &&
              <>
                <div className="translator d-flex f-100">
                    <aside style={{ left: showSidebar ? '0' : '' }} className="position-relative z-3">
                        <Link to="/">
                            <div className="navBar__logo m-10">
                                <img className="" src={Logo} alt="OneConverse" />
                            </div>
                        </Link>

                        <Close className="sidebar__close position-absolute t-0 r-0 m-5" onClick={() => setShowSidebar(false)} />
                        
                        {(!loading && section === "profile") &&
                            <>
                                <div className="d-flex align-center justify-center position-relative">
                                    <img className="translator__profile__img border-1 m-5" src={user.profileImage} alt="" />
                                    <label className="translator__avatar__edit d-flex align-center justify-center position-absolute rounded-50 pointer">
                                        <input className="position-absolute r-0 hidden" type="file" onChange={handleChange} />
                                        <EditOutlined />
                                    </label>
                                </div>
                                <div className="translator__about overflow-auto">
                                    <div className="p-20 my-10 text-center">
                                        <h3 className="mb-10 text-capitalise">{user.title} {user.name}</h3>
                                        {(user.membership.applied && !user.membership.approved) &&
                                            <span style={{ background: 'rgb(114, 63, 0)' }} className="py-5 px-10 curved-20 font-sm font-bolder">
                                                Reviewing
                                            </span>
                                        }
                                        {(!user.membership.applied && !user.membership.approved) &&
                                            <div className="d-flex flex-column">
                                                <div className="mb-10">
                                                    <span style={{ background: 'darkred' }} className="py-5 px-10 curved-20 font-sm font-bolder">
                                                        Declined
                                                    </span>
                                                </div>
                                                <div className="d-flex justify-center mt-5">
                                                    <button style={{ backgroundColor: 'rgb(9, 172, 0)', color: '#fff' }} className="px-10 rounded font-normal font-bolder mr-20" onClick={() => openModal('apply')}>
                                                        Re-apply
                                                    </button>
                                                    <button style={{ backgroundColor: '#039fbe', color: '#fff' }} className="px-10 rounded font-sm font-bolder" onClick={() => setShowMessage(true)}>
                                                        <EmailOutlined />
                                                    </button>
                                                </div>
                                            </div>
                                        }
                                        {(!user.membership.applied && user.membership.approved) &&
                                            <div>
                                                <div>
                                                    <StarRate style={{ color: rating > 0.49 ? 'rgb(0, 172, 0)' : '' }} />
                                                    <StarRate style={{ color: rating > 1.49 ? 'rgb(0, 172, 0)' : '' }} />
                                                    <StarRate style={{ color: rating > 2.49 ? 'rgb(0, 172, 0)' : '' }} />
                                                    <StarRate style={{ color: rating > 3.49 ? 'rgb(0, 172, 0)' : '' }} />
                                                    <StarRate style={{ color: rating > 4.49 ? 'rgb(0, 172, 0)' : '' }} />
                                                </div>
                                                <div>
                                                    ( {user?.rating ? `${user.rating.total_rating} rating${user.rating.total_rating > 1 ? 's' : ''}` : '0 rating'} )
                                                </div>
                                            </div>
                                        }
                                    </div>
                                    <p className="word-break p-20">
                                        {user.bio}
                                    </p>
                                    <div className="px-20">
                                        <h4 className="font-big mb-5">Expertise</h4>
                                        <div className="d-flex flex-wrap">
                                            {user.expertise.map(area =>
                                                <span className="translator__expertise p-5 m-5 curved-20 font-bold font-xsm" key={area}>
                                                    {area}
                                                </span>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </>
                        }
                        {section !== "profile" && <Sidebar section={section} setShowSidebar={setShowSidebar} translator/>}
                    </aside>
                    <main className="py-10 pb-40">
                        <div className="translator__topBar d-flex align-center justify-between mb-40 px-40 py-10">
                            <Menu className="translator__logo" onClick={() => setShowSidebar(true)} />
                            {(!loading && section === "profile") && <h2 className="font-bigger">{user.name.split(' ')[0]}</h2>}
                            {section !== "profile" && <Link to="/translator/profile" className="font-bigger font-bold">Profile Page</Link>}
                            <div className="d-flex align-center">
                                {auth && 
                                    <details className="navBar__details position-relative">
                                        <summary className="d-flex align-center list-none pointer">
                                            <div className="holder__logo d-flex align-center justify-center font-subhead font-bolder text-center rounded-50">
                                                <span className="text-uppercase">{auth.name.split(' ')[0].charAt(0)}</span>
                                            </div>
                                            <ArrowDropDown className="icon-light-grey" fontSize="large" />
                                        </summary>
                                        <div className="navBar__drop position-absolute r-0 mt-20 z-3 box-shadow-lg">
                                            <p className="text-capitalise font-big font-bolder text-center px-40 my-10">Hi, {auth.name.split(' ')[0]}</p>
                                            <div className="d-flex align-center font-bold py-10 px-20 w-100 border-top-1 pointer" onClick={handleToDashboard}>
                                                <DashboardOutlined fontSize="small" className="mr-20" />
                                                <span>Your Dashboard</span>
                                            </div>
                                            <div className="d-flex align-center font-bold py-10 px-20 w-100 border-top-1 pointer" onClick={() => history.push('/settings')}>
                                                <SettingsOutlined fontSize="small" className="mr-20" />
                                                <span>Settings</span>
                                            </div>
                                            <div style={{ color: 'crimson' }} className="d-flex align-center font-bold py-10 px-20 w-100 border-top-1 pointer" onClick={logout}>
                                                <ExitToApp fontSize="small" className="mr-20" />
                                                <span>Log Out</span>
                                            </div>
                                        </div>
                                    </details>
                                }
                            </div>
                        </div>
                        <div className="translator__main px-40">
                            {section === "profile" && <Profile user={user} loading={loading} />}
                            {section === "index" && <Index user={user} />}
                            {section === "new" && <New user={user} setUser={setUser} section={section} />}
                            {section === "ongoing" && <Ongoing user={user} setUser={setUser} section={section} />}
                            {section === "declined" && <Declined user={user} setUser={setUser} section={section} />}
                        </div>
                    </main>
                </div>
                <div style={{ right: showMessage ? 0 : '' }} className="translator__declined__msg position-fixed h-100 t-0 z-4 overflow-auto">
                    <h3 className="position-sticky d-flex align-center p-20 pointer border-bottom-1 t-0" onClick={() => setShowMessage(false)}>
                        <KeyboardArrowLeft style={{ fontSize: '36px' }}/>
                        Registration Guide
                    </h3>
                    <div className="d-flex flex-column px-20 py-10 border-bottom-1">
                        <span className="font-bold font-big">Admin</span>
                        <span className="lh-lg">{user?.rejection_msg?.message}</span>
                        <time className="font-sm font-bolder text-right">{dayjs(user?.rejection_msg?.createdAt).fromNow()}</time>
                    </div>
                </div>
                <details className="translator__details">
                    <summary className="list-none"></summary>
                    <div className="d-flex align-center justify-center position-fixed t-0 r-0 w-100 h-100 z-5">
                        {type === "apply" &&
                            <div className="d-flex flex-column align-center text-center p-20">
                                <h3 className="font-subhead">Reapply to become a translator</h3>
                                <p className="font-heavy font-big py-40">
                                    Your profile will be reviewed before you are approved as a translator on OneConverse
                                </p>
                                <div className="d-flex justify-between">
                                    <button className="unapproved__btn__cancel border-0 outline-0 p-10 font-normal font-bold w-45 rounded" onClick={closeModal}>Cancel</button>
                                        <button 
                                        className="unapproved__btn__aprrove d-flex justify-center align-center border-0 outline-0 p-10 font-normal font-bold w-45 rounded" 
                                        onClick={handleReapply}>
                                            Re-apply
                                            {reapplying && <div className="spin-white ml-10"></div>}
                                    </button>
                                </div>
                            </div>
                        }
                        {type === "image" &&
                            <div className="d-flex flex-column align-center text-center p-20">
                                <h3 className="font-subhead">Change profile image</h3>
                                <img className="translator__details__img my-40" src={image} alt="" />
                                <div className="d-flex justify-between">
                                    <button className="unapproved__btn__cancel border-0 outline-0 p-10 font-normal font-bold w-45 rounded" onClick={closeModal}>Cancel</button>
                                    <button 
                                      className="unapproved__btn__aprrove d-flex justify-center align-center border-0 outline-0 p-10 font-normal font-bold w-45 rounded" 
                                      onClick={handleChangeImage}>
                                        Change
                                        {changing && <div className="spin-white ml-10"></div>}
                                    </button>
                                </div>
                            </div>
                        }
                    </div>
                </details>
              </>
            }
        </>
    )
}

export default Translator
